import { render, staticRenderFns } from "./AddVendorDetail.vue?vue&type=template&id=1d16fef4&"
import script from "./AddVendorDetail.vue?vue&type=script&lang=js&"
export * from "./AddVendorDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddVendorDetail.vue?vue&type=style&index=0&id=1d16fef4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports